module.exports = __webpack_public_path__ + "img/feature_6.e6993132.svg";